// extracted by mini-css-extract-plugin
export default {"list":"UserList_list__O6M1K"};